export class SessionHelper {
  public static getMyProjectList() {
    return sessionStorage.getItem("MyProjectList");
  }

  public static setMyProjectList(MyProjectList: string) {
    sessionStorage.setItem("MyProjectList", MyProjectList);
  }
  public static getPortalProjectList() {
    return sessionStorage.getItem("PortalProjectList");
  }

  public static setPortalProjectList(PortalProjectList: string) {
    sessionStorage.setItem("PortalProjectList", PortalProjectList);
  }
  public static getPortalTaskList() {
    return sessionStorage.getItem("PortalTaskList");
  }
  public static setPortalTaskList(PortalTaskList: string) {
    sessionStorage.setItem("PortalTaskList", PortalTaskList);
  }
  public static getCustomer() {
    return sessionStorage.getItem("customer");
  }

  public static setCustomer(customer: string) {
    sessionStorage.setItem("customer", customer);
  }
  public static clearCustomer() {
    sessionStorage.removeItem("customer");
  }
  public static getCustomers() {
    return sessionStorage.getItem("customers");
  }

  public static setCustomers(customers: string) {
    sessionStorage.setItem("customers", customers);
  }
  public static clearCustomers() {
    sessionStorage.removeItem("customers");
  }
  public static getIdToken() {
    return sessionStorage.getItem("id_token");
  }

  public static setIdToken(idtoken: string) {
    sessionStorage.setItem("id_token", idtoken);
  }
  public static getRefreshToken() {
    return sessionStorage.getItem("refresh_token");
  }

  public static setRefreshToken(refreshtoken: string) {
    sessionStorage.setItem("refresh_token", refreshtoken);
  }
  public static getUserSub() {
    return localStorage.getItem("user_sub");
  }

  public static setUserSub(usersub: string) {
    localStorage.setItem("user_sub", usersub);
  }
  public static getUserName() {
    return localStorage.getItem("username");
  }

  public static setUserName(username: string) {
    localStorage.setItem("username", username);
  }
  public static getUserEmail() {
    return sessionStorage.getItem("user_email");
  }

  public static setUserEmail(useremail: string) {
    sessionStorage.setItem("user_email", useremail);
  }
  public static getPerson() {
    return sessionStorage.getItem("person");
  }

  public static setPerson(person: string) {
    sessionStorage.setItem("person", person);
  }
  public static getChoosenOrg() {
    return sessionStorage.getItem("choosenorg");
  }

  public static setChoosenOrg(choosenorg: string) {
    sessionStorage.setItem("choosenorg", choosenorg);
  }
  public static getPersonOrgs() {
    return sessionStorage.getItem("personorgs");
  }

  public static setPersonOrgs(personorgs: string) {
    sessionStorage.setItem("personorgs", personorgs);
  }

  // Org modules (org.modules is a comma-separated text field, e.g.
  // "projects,planning,portal,timereg") gate whole features on/off per
  // organization. See top-nav.component.ts's setModules() for the same
  // check done inline for the built-in modules.
  public static hasModule(moduleName: string): boolean {
    let orgs: any[] = [];
    try {
      orgs = JSON.parse(SessionHelper.getPersonOrgs() || "[]");
    } catch (_error) {
      return false;
    }
    if (!Array.isArray(orgs)) {
      orgs = [orgs];
    }
    const currentOrg = orgs.find(
      (org) => org && org.organizationId == SessionHelper.getChoosenOrg()
    );
    if (!currentOrg || !currentOrg.modules) {
      return false;
    }
    return String(currentOrg.modules)
      .split(",")
      .map((entry) => entry.trim().toLowerCase())
      .includes(moduleName.toLowerCase());
  }
  public static getCurrentProject() {
    return sessionStorage.getItem("currentproject");
  }

  public static setCurrentProject(currentProject: string) {
    sessionStorage.setItem("currentproject", currentProject);
  }
  public static getCurrentProjectName() {
    return sessionStorage.getItem("currentprojectname");
  }

  public static setCurrentProjectName(currentProject: string) {
    sessionStorage.setItem("currentprojectname", currentProject);
  }
  public static getCurrentProjectRoles(projectId: string) {
    return sessionStorage.getItem("currentprojectnameroles"+projectId);
  }

  public static setCurrentProjectRoles(currentProjectRoles: string, projectId: string) {
    sessionStorage.setItem("currentprojectnameroles"+projectId, currentProjectRoles);
  }
  public static setRoles(roles: string) {
    return sessionStorage.setItem("projectroles", roles);
  }
  public static getRoles() {
    return sessionStorage.getItem("projectroles");
  }
  public static getCurrentProjectFull() {
    return sessionStorage.getItem("currentprojectfull");
  }

  public static setCurrentProjectFull(currentProject: string) {
    sessionStorage.setItem("currentprojectfull", currentProject);
  }
  public static getPersonAuth() {
    return sessionStorage.getItem("personauth");
  }

  public static setPersonAuth(personauth: string) {
    sessionStorage.setItem("personauth", personauth);
  }
  public static getDynamicStyle() {
    return sessionStorage.getItem("dynstyle");
  }

  public static setDynamicStyle(style: string) {
    sessionStorage.setItem("dynstyle", style);
  }
  public static getIsWhitelabel() {
    return sessionStorage.getItem("IsWhitelabel");
  }

  public static setIsWhitelabel() {
    sessionStorage.setItem("IsWhitelabel", "true");
  }
  public static clearIsWhitelabel() {
    sessionStorage.removeItem("IsWhitelabel");
  }
  public static getHubspot() {
    return sessionStorage.getItem("hubspot");
  }
  public static setHubspot() {
    sessionStorage.setItem("hubspot", "true");
  }
  public static clearHubspot() {
    sessionStorage.removeItem("hubspot");
  }
  public static setUserview(uv: string) {
    sessionStorage.setItem("Userview", uv);
  }
  public static getUserview() {
    return sessionStorage.getItem("Userview");
  }
  public static setTaskAnimation(ta: string) {
    sessionStorage.setItem("TaskAnimation", ta);
  }
  public static getTaskAnimation() {
    return sessionStorage.getItem("TaskAnimation");
  }
  public static setViewAsCustomer(vac: string) {
    sessionStorage.setItem("ViewAsCustomer", vac);
  }
  public static getViewAsCustomer() {
    return sessionStorage.getItem("ViewAsCustomer");
  }
  public static clearViewAsCustomer() {
    sessionStorage.removeItem("ViewAsCustomer");
  }
  public static getPortalProjectPersonList() {
    return sessionStorage.getItem("PortalProjectPersonList");
  }
  public static setPortalProjectPersonList(PortalProjectPersonList: string) {
    sessionStorage.setItem("PortalProjectPersonList", PortalProjectPersonList);
  }
  public static getPortalOrgMembers() {
    return sessionStorage.getItem("PortalOrgMembers");
  }
  public static setPortalOrgMembers(PortalOrgMembers: string) {
    sessionStorage.setItem("PortalOrgMembers", PortalOrgMembers);
  }  
  public static getCustomersUsers() {
    return sessionStorage.getItem("CustomersUsers");
  }
  public static setCustomersUsers(CustomersUsers: string) {
    sessionStorage.setItem("CustomersUsers", CustomersUsers);
  }
  public static setChatShow(show: string) {
    sessionStorage.setItem("ChatShow", show);
  }
  public static getChatShow() {
    return sessionStorage.getItem("ChatShow");
  }
  //getImageCache
  public static getImageCache() {
    return sessionStorage.getItem("ImageCache");
  }
  public static setImageCache(ImageCache: string) {
    sessionStorage.setItem("ImageCache", ImageCache);
  }
  //getLanguage
  public static getLanguage() {
    return sessionStorage.getItem("Language");
  }
  public static setLanguage(Language: string) {
    sessionStorage.setItem("Language", Language);
  }
  public static clear() {
    sessionStorage.clear();
    localStorage.clear(); 
  }
}
